// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__DdvDZ","small":"styles_small__c4xST","medium":"styles_medium__DqIkA","large":"styles_large__4-lHR"};